import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { AnnualAccountFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import * as Yup from "yup";
import { AnnualAccountCommentFormContainerProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import AnnualAccountCommentForm from "./commentForm";
import { useAnnualAccountService } from "serviceHooks";
//#endregion

const AnnualAccountRejectFormContainer: ForwardRefRenderFunction<FormHandles, AnnualAccountCommentFormContainerProps> = (
  props,
  ref
) => {
  const annualAccountService = useAnnualAccountService();
  const validationSchema = Yup.object<AnnualAccountFormTypes.Comment>({
    message: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = (values: AnnualAccountFormTypes.Comment) => {
    return annualAccountService.commentAnnualAccountReport(props.id, values.message);
  };

  return (
    <AnnualAccountCommentForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(AnnualAccountRejectFormContainer);
